export default "__VITE_ASSET__fe72b234__"